module.exports = __webpack_public_path__ + "img/1_010.4cdb3a24.jpg";